"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Record = void 0;
const model_1 = require("../model");
/**
 * Record operations
 */
class Record {
    /**
     * @hidden
     */
    constructor(datasheetId, wCtx, recordId) {
        this.datasheetId = datasheetId;
        this.wCtx = wCtx;
        this.recordId = recordId;
        this.modelRecord = new model_1.Record(this.datasheetId, this.wCtx, this.recordId);
    }
    /**
     * The unique ID of the record.
     *
     * @returns
     *
     * #### Example
     * ```js
     * console.log(myRecord.id);
     * // => 'recxxxxxx'
     */
    get id() {
        return this.recordId;
    }
    /**
     * The cell value of the primary field of cells.
     * The primary field is usually seen as the main field.
     *
     * @returns
     *
     * #### Example
     * ```js
     * console.log(myRecord.title);
     * // => '42'
     * ```
     */
    get title() {
        return this.modelRecord.title;
    }
    /**
     * The comment counts of the record.
     *
     * @returns
     *
     * #### Example
     * ```js
     * console.log(myRecord.commentCount); // => 10
     */
    get commentCount() {
        return this.modelRecord.commentCount;
    }
    /**
     * Get the cell value of a specified cell in record.
     *
     * @param fieldId The ID of the field.
     * @returns
     *
     * #### Example
     * ```js
     * const cellValue = myRecord.getCellValue(mySingleLineTextFieldId);
     * console.log(cellValue); // => 'cell value'
     * ```
     */
    getCellValue(fieldId) {
        return this.modelRecord.getCellValue(fieldId);
    }
    /**
     * Get the cell value of a specified cell in record, and convert it to a string type.
     *
     * @returns
     *
     * #### Example
     * ```js
     * const stringValue = myRecord.getCellValueString(myNumberFieldId);
     * console.log(stringValue); // => '42'
     * ```
     */
    getCellValueString(fieldId) {
        return this.modelRecord.getCellValueString(fieldId);
    }
    /**
     * The url of the record.
     *
     * @param viewId
     *
     * @returns
     *
     * #### Example
     * ```js
     * console.log(myRecord.getUrl('viwxxxxxx'));
     * ```
     */
    getUrl(viewId) {
        return this.modelRecord.url(viewId);
    }
}
exports.Record = Record;
